// Phase 24 polish — one set of form-control classes shared by QuoteForm,
// the Calculator lead form, EnergySwitch and any future capture surface.
// Previously each form carried its own copy with different heights (h-10 /
// h-11 / h-12), radii and focus rings.

export const inputCls =
  "h-11 w-full px-3.5 rounded-lg bg-white border border-border text-[15px] text-ink placeholder:text-subtle/70 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 transition";

export const selectCls = `${inputCls} appearance-none pr-9`;

export const textareaCls =
  "w-full px-3.5 py-3 rounded-lg bg-white border border-border text-[15px] text-ink placeholder:text-subtle/70 focus:outline-none focus:border-brand-blue focus:ring-2 focus:ring-brand-blue/20 transition resize-y";

export const labelCls = "text-[12.5px] font-medium text-ink";

export const errorCls = "text-[12px] text-red-600";

export const fineprintCls = "text-[12px] leading-relaxed text-subtle";
